// extracted by mini-css-extract-plugin
export default {"siderContainer":"Sider_siderContainer__nKv2U"};